import { Frame, Loading } from '@shopify/polaris';
import {useHistory, useParams} from 'react-router-dom';
import { useCallback, useEffect, useState } from 'react';
import Form, { Skeleton } from './Form';
import Api from '../../helpers/api';
import formatErrors from '../../helpers/format_errors';
import {useAppBridge} from '@shopify/app-bridge-react';

export default () => {
    const history = useHistory();
    const {discountCodeId} = useParams();
    const [saving, setSaving] = useState(false);
    const [errors, setErrors] = useState({});
    const [loading, setLoading] = useState(true);
    const [model, setModel] = useState(null);
    const [stats, setStats] = useState({
        number_of_usage: 0,
        total_sales: 0.0,
        total_discount_amount: 0.0,
        average_discount_amount: 0.0
    });
    const shopify = useAppBridge();

    useEffect(() => {
        Api.getDiscountCode(discountCodeId)
            .then(response => {
                setStats({
                    number_of_usage: response.data.number_of_usage,
                    total_sales: response.data.total_sales,
                    total_discount_amount: response.data.total_discount_amount,
                    average_discount_amount: response.data.average_discount_amount,
                });
                setModel(response.data.data);
                setLoading(false);
            });
    }, [discountCodeId]);

    const handleSubmit = useCallback((data) => {
        setSaving(true);

        Api.updateDiscountCode(model.id, data)
            .then(() => {
                shopify.toast.show('The discount code has been updated', {});
            })
            .catch(error => {
                if ( error?.response?.status == 422 ) {
                    setErrors(formatErrors( error.response.data ));
                } else {
                    throw error;
                }
            })
            .finally(() => {
                setSaving(false);
            });
    }, [model]);

    const handleDelete = useCallback(() => {
        setSaving(true);

        Api.deleteDiscountCode(model.id)
            .then(() => {
                shopify.toast.show('The discount code has been deleted', {});
                history.push(`/discount-codes`);
            })
            .catch(error => {
                if ( error?.response?.status == 422 ) {
                    setErrors(formatErrors( error.response.data ));
                } else {
                    throw error;
                }
            })
            .finally(() => {
                setSaving(false);
            });
    }, [model]);

    useEffect(() => {
        if (window.location.search.includes('created=1')) {
            shopify.toast.show('The discount code has been created', {});
        }
    }, []);

    return (
        <Frame>
            {saving && <Loading />}
            {loading
                ? <Skeleton />
                : <Form handleSubmit={handleSubmit} saving={saving} errors={errors} model={model} handleDelete={handleDelete} stats={stats} />
            }
        </Frame>
    )
}
